export enum AlertType {
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
  NOTIFICATION = 'notification',
  CRITICAL = 'critical',
}
